import { useEffect } from 'react';
import { getAutoLockMinutes } from '@/services/appSession';
import { useSession } from '../state/session';

const ACTIVITY = ['pointerdown', 'keydown', 'touchstart', 'wheel', 'scroll'] as const;

/**
 * 무활동 자동잠금 + 백그라운드 전환 후 경과 시간 잠금 (SYNC_SECURITY §7).
 * 입력은 즉시 저장되므로 잠겨도 내용은 사라지지 않는다 (M2 autosave).
 */
export function useAutoLock(active: boolean) {
  const lock = useSession((s) => s.lock);

  useEffect(() => {
    if (!active) return;
    let minutes = 10;
    let last = Date.now();
    let hiddenAt: number | null = null;
    let cancelled = false;
    void getAutoLockMinutes().then((m) => {
      if (!cancelled) minutes = m;
    });

    const touch = () => {
      last = Date.now();
    };
    const tick = () => {
      if (Date.now() - last >= minutes * 60_000) lock();
    };
    const onVisibility = () => {
      if (document.visibilityState === 'hidden') hiddenAt = Date.now();
      else {
        if (hiddenAt !== null && Date.now() - hiddenAt >= minutes * 60_000) lock();
        hiddenAt = null;
        touch();
      }
    };

    ACTIVITY.forEach((e) => window.addEventListener(e, touch, { passive: true, capture: true }));
    document.addEventListener('visibilitychange', onVisibility);
    const timer = window.setInterval(tick, 15_000);
    return () => {
      cancelled = true;
      ACTIVITY.forEach((e) => window.removeEventListener(e, touch, { capture: true }));
      document.removeEventListener('visibilitychange', onVisibility);
      window.clearInterval(timer);
    };
  }, [active, lock]);
}
